/**
 * Actionable Recommendations – frontend (mirrors BooksyAppExpo logic)
 */

export function generateRecommendations(kpiData, options = {}) {
  const recommendations = [];
  const {
    completionRate = 0,
    cancellationRate = 0,
    revenue = 0,
    total = 0,
    totalAppointments = 0,
  } = kpiData;
  const totalOrAppointments = total || totalAppointments;
  const { lang = 'en' } = options;
  const avgBookingValue = Number(kpiData.avgBookingValue) || 0;

  if (parseFloat(completionRate) < 70) {
    recommendations.push({
      id: 'low-completion-rate',
      priority: 'high',
      category: 'bookings',
      title: lang === 'ar' ? 'معدل الإكمال منخفض' : 'Low Completion Rate',
      message: lang === 'ar'
        ? 'معدل الإكمال الحالي أقل من المستوى المثالي (70%+). راجع عملية الموافقة على الحجوزات.'
        : 'Current completion rate is below ideal (70%+). Review your booking acceptance process.',
      actions: [
        lang === 'ar' ? 'تحسين وقت الاستجابة للحجوزات' : 'Improve response time to bookings',
        lang === 'ar' ? 'مراجعة معايير القبول/الرفض' : 'Review acceptance/decline criteria',
      ],
      impact: 'high',
    });
  }

  if (parseFloat(cancellationRate) > 15) {
    recommendations.push({
      id: 'high-cancellation-rate',
      priority: 'high',
      category: 'bookings',
      title: lang === 'ar' ? 'معدل الإلغاء مرتفع' : 'High Cancellation Rate',
      message: lang === 'ar'
        ? 'معدل الإلغاء مرتفع جداً. هذا يؤثر سلباً على الإيرادات.'
        : 'Cancellation rate is too high. This negatively impacts revenue.',
      actions: [
        lang === 'ar' ? 'تحسين تجربة العملاء' : 'Improve customer experience',
        lang === 'ar' ? 'إرسال تذكيرات قبل الموعد' : 'Send reminders before appointments',
      ],
      impact: 'high',
    });
  }

  const avgRev = avgBookingValue > 0
    ? avgBookingValue
    : (totalOrAppointments > 0 ? revenue / totalOrAppointments : 0);
  if (totalOrAppointments > 0 && avgRev < 50) {
    recommendations.push({
      id: 'low-average-revenue',
      priority: 'medium',
      category: 'revenue',
      title: lang === 'ar' ? 'متوسط الإيرادات منخفض' : 'Low Average Revenue',
      message: lang === 'ar'
        ? 'متوسط الإيرادات لكل حجز منخفض. فكر في استراتيجيات البيع الإضافي.'
        : 'Average revenue per booking is low. Consider upselling strategies.',
      actions: [
        lang === 'ar' ? 'عرض خدمات إضافية' : 'Offer additional services',
        lang === 'ar' ? 'إنشاء حزم خدمات' : 'Create service packages',
      ],
      impact: 'medium',
    });
  }

  if (totalOrAppointments < 10) {
    recommendations.push({
      id: 'low-booking-volume',
      priority: 'medium',
      category: 'bookings',
      title: lang === 'ar' ? 'حجم الحجوزات منخفض' : 'Low Booking Volume',
      message: lang === 'ar'
        ? 'عدد الحجوزات منخفض. ركز على التسويق وجذب عملاء جدد.'
        : 'Booking volume is low. Focus on marketing and attracting new customers.',
      actions: [
        lang === 'ar' ? 'زيادة جهود التسويق' : 'Increase marketing efforts',
        lang === 'ar' ? 'عروض ترويجية للعملاء الجدد' : 'Promotional offers for new customers',
      ],
      impact: 'medium',
    });
  }

  if (parseFloat(completionRate) >= 85 && parseFloat(cancellationRate) < 10) {
    recommendations.push({
      id: 'excellent-performance',
      priority: 'low',
      category: 'general',
      title: lang === 'ar' ? 'أداء ممتاز!' : 'Excellent Performance!',
      message: lang === 'ar'
        ? 'أداء رائع! استمر في العمل الجيد!'
        : 'Great performance! Keep up the good work!',
      actions: [
        lang === 'ar' ? 'الحفاظ على المعايير العالية' : 'Maintain high standards',
        lang === 'ar' ? 'طلب تقييمات من العملاء' : 'Request customer reviews',
      ],
      impact: 'low',
      isPositive: true,
    });
  }

  const priorityOrder = { high: 3, medium: 2, low: 1 };
  return recommendations.sort((a, b) => priorityOrder[b.priority] - priorityOrder[a.priority]);
}
